import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class CanNavigateGuard implements CanActivate {
  constructor(private router: Router) {}

  public canActivate(): boolean {
    const routerState = this.router.currentNavigation().extras.state;
    if (routerState?.bypassGuard) {
      return true;
    }
    // this logic is added as there is an issue in routing mentioned in https://github.com/angular/angular/issues/16211
    this.router.navigate(['/']);
    return false;
  }
}
